import React, { createContext, useContext, useState, useEffect } from "react";
import { api } from "../lib/api";
import { useAuth } from "./AuthContext";
import UpgradeModal from "../components/UpgradeModal";

const UpgradeContext = createContext(null);
export const useUpgrade = () => useContext(UpgradeContext);

export function UpgradeProvider({ children }) {
  const { user } = useAuth();
  const [open, setOpen] = useState(false);
  const [reason, setReason] = useState("");
  const [loading, setLoading] = useState(false);
  const [subscription, setSubscription] = useState(null);

  const isPro = user?.plan === "pro";

  useEffect(() => {
    if (isPro) {
      api.get("/subscription/status").then((r) => setSubscription(r.data)).catch(() => {});
    } else {
      setSubscription(null);
    }
  }, [isPro]);

  const openUpgrade = (r) => {
    setReason(r || "");
    setOpen(true);
  };

  const startCheckout = async () => {
    setLoading(true);
    try {
      const res = await api.post("/payments/checkout", { origin_url: window.location.origin });
      window.location.href = res.data.checkout_url;
    } catch (e) {
      setLoading(false);
    }
  };

  const openBillingPortal = async () => {
    try {
      const res = await api.post("/subscription/portal", { return_url: window.location.origin });
      window.location.href = res.data.url;
    } catch (e) {}
  };

  return (
    <UpgradeContext.Provider value={{ isPro, openUpgrade, openBillingPortal, subscription }}>
      {children}
      <UpgradeModal open={open} onOpenChange={setOpen} reason={reason} onUpgrade={startCheckout} loading={loading} />
    </UpgradeContext.Provider>
  );
}
